import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { AssignMethodCredits } from "pages/admin/partners/AssignMethodCredits";
import { AssignModuleCredits } from "pages/admin/partners/AssignModuleCredits";
import { PartnerList } from "pages/admin/partners/PartnerList";
import { PredictedHaInConversion } from "pages/admin/partners/PredictedHaInConversion";

export const Partners = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Partners",
      key: "partners",
      component: <PartnerList />,
    },
    {
      name: "Method credits",
      key: "method-credits",
      component: <AssignMethodCredits />,
    },
    {
      name: "Module credits",
      key: "module-credits",
      component: <AssignModuleCredits />,
    },
    {
      name: "Predictions",
      key: "predictions",
      component: <PredictedHaInConversion />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `partners/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/partners/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
